var parameterRegExp: RegExp = /\{(\w+)\}/g;

export function stringFormat(format: string, parameters: NPS.Common.ITypedObject<any>) {
    if (format) {
        format = format.replace(parameterRegExp, (match: string, name: string) => {
            var replacement: string;
            if (parameters && parameters[name]) {
                replacement = parameters[name].toString();
            } else {
                replacement = "";
            }
            return replacement;
        });
    }
    return format;
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Helpers/StringFormat.ts